import { useIntl } from 'react-intl';
import { Form, Input, Checkbox, FormInstance } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { VehicleAccessoryFormValues } from '@/core/domain/people/Accessory/Accessory.types';
import {
  useDefaultEmptyFieldError,
  useDefaultMaxLengthFieldError,
} from '@/hooks';

interface AccessoriesGeneralFormProps {
  form: FormInstance<VehicleAccessoryFormValues>;
}

function AccessoriesGeneralForm({ form }: AccessoriesGeneralFormProps) {
  const intl = useIntl();
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  return (
    <Form form={form}>
      <FloatingFormItem
        label={intl.formatMessage({
          id: 'accessories.general.form.description',
        })}
        name="description"
        rules={[defaultEmptyFieldError, defaultMaxLenghtFieldError(100)]}
      >
        <Input />
      </FloatingFormItem>

      <Form.Item
        name="checkList"
        initialValue={false}
        valuePropName="checked"
        style={{ marginTop: '16px' }}
      >
        <Checkbox>
          {intl.formatMessage({
            id: 'accessories.modal.checklist',
          })}
        </Checkbox>
      </Form.Item>
    </Form>
  );
}

export default AccessoriesGeneralForm;
